module.exports = __webpack_public_path__ + "static/media/ti-suport.f842c782.webp";